import React from "react";
import PropTypes from "prop-types";
import {Dropdown} from "react-bootstrap";

const componentName = "DropDownMenu"

const DropDownMenu = ({ idx, onItemClick, items = [] }) => {
  return (
    <Dropdown
      id={`${componentName}-dropDown-${idx}`}
      key={`${componentName}-dropDown-key-${idx}`}
    >
      <Dropdown.Toggle
        variant="link"
        id={`${componentName}-menuToggle-${idx}`}
        key={`${componentName}-menuToggle-key-${idx}`}
        className="p-0 border-0"
        aria-label="Actions"
      >
        <span id={`${componentName}-actionIcon`} aria-hidden="true">
          <i className="fa-solid fa-ellipsis border-0 text-dark"></i>
        </span>
      </Dropdown.Toggle>
      <Dropdown.Menu
        id={`${componentName}-dropDownMenu-${idx}`}
        key={`${componentName}-dropDownMenu-key-${idx}`}
        style={{ maxHeight: '250px' }}
        className='dropdown-menu-aligned'
      >
        {items?.map((item, itemIdx) => {
          const itemKey = item.value ?? item.text ?? itemIdx;

          return (
            <React.Fragment key={`${componentName}-itemGroup-${itemKey}-${itemIdx}`}>
              {item.hasDivider &&
                <Dropdown.Divider
                  id={`${componentName}-itemDivider-${itemIdx}`}
                />
              }
              <Dropdown.Item
                id={`${componentName}-item-${itemIdx}`}
                onClick={() => { onItemClick(item); }}
                disabled={item?.disabled}
                {...item?.extra}
              >{item.text}</Dropdown.Item>
            </React.Fragment>
          )
        })}
      </Dropdown.Menu>
    </Dropdown>
  )
}

DropDownMenu.propTypes = {
  idx: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onItemClick: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    disabled: PropTypes.bool,
    extra: PropTypes.object,
    hasDivider: PropTypes.bool,
    text: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }))
};

export default DropDownMenu;
